const SRP_LOAN_TYPE = [
  { text: 'Yes', value: 'yes' },
  { text: 'No', value: 'no' },
];
export default SRP_LOAN_TYPE;



// WEBPACK FOOTER //
// ./src/constants/srpLoan.js